
import { defineComponent } from 'vue';

import { HomeViewSetup } from '@/views/HomeViewBase';

import TopNewsSwiperComponent from '@/components/pc/TopNewsSwiperComponent.vue';
import RgTopComponent from '@/components/pc/RgTopComponent.vue';
import MovieFilmComponent from '@/components/pc/MovieFilmComponent.vue';
import ClientCustomComponent from '@/components/pc/ClientCustomComponent.vue';
import TopRankingComponent from '@/components/pc/TopRankingComponent.vue';
import NkCnbcMenuComponent from '@/components/pc/NkCnbcMenuComponent.vue';

export default defineComponent({
  name: 'PcHomeView',
  components: {
    TopNewsSwiperComponent,
    RgTopComponent,
    MovieFilmComponent,
    ClientCustomComponent,
    TopRankingComponent,
    NkCnbcMenuComponent
  },  
  setup() {
    return HomeViewSetup();
  }
});
